import {
  GET_FACE_BATCH_RESULT,
  GET_FACE_BATCH_RESULT_SUCCESS,
  GET_FACE_BATCH_RESULT_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getFaceBatchResultReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FACE_BATCH_RESULT:
      return { ...state, loading: true };
    case GET_FACE_BATCH_RESULT_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_FACE_BATCH_RESULT_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getFaceBatchResultReducer;
